import calculateBreakHelpPartner from 'Domain/monitoring/helper/calculateBreakHelpPartner';
import calculateBreakViolation from 'Domain/monitoring/helper/calculateBreakViolation';
import calculateTimeDifference from 'Domain/monitoring/helper/calculateTimeDifference';
import getFormatTimeToHHMM from 'Domain/monitoring/helper/getFormatTimeToHHMM';
import { isNumber } from 'lodash';

const getMonitoringStatusResponse = (response) => {
  const shift = response?.operatorStatus?.shift ?? {};
  const startedBreak = response?.operatorStatus?.startedAt;
  const maxBreakDuration = response?.operatorStatus?.breakDetail?.maxDurationMin;
  const remainingDurationMin = response?.operatorStatus?.breakDetail?.remainingDurationMin;
  const remainingDurationSec = response?.operatorStatus?.breakDetail?.remainingDurationSec;
  const isHelpPartnerBreak = response?.operatorStatus?.breakCode === 'BANTU_REKAN';
  const helpRequest = response?.operatorStatus?.breakDetail?.helpRequest;

  let dateTime = null;
  let timeDiff = 0;
  let breakViolationDuration = 0;
  let helpPartnerDuration = 0;

  if (shift?.startTime && shift?.endTime) {
    const startShift = getFormatTimeToHHMM(shift?.startTime);
    const endShift = getFormatTimeToHHMM(shift?.endTime);

    dateTime = `${startShift} - ${endShift}`;
  }

  if (startedBreak && isNumber(remainingDurationMin)) timeDiff = calculateTimeDifference(startedBreak, remainingDurationMin, remainingDurationSec);
  if (isNumber(maxBreakDuration)) breakViolationDuration = calculateBreakViolation(startedBreak, maxBreakDuration);
  if (isHelpPartnerBreak) helpPartnerDuration = calculateBreakHelpPartner(startedBreak);

  return {
    status: response?.operatorStatus?.status,
    shift: { ...shift, dateTime },
    presence: {
      id: response?.operatorStatus?.operatorPresenceId,
      deviceId: response?.operatorStatus?.deviceId,
      clockInAt: response?.operatorStatus?.clockInAt,
    },
    break: {
      name: response?.operatorStatus?.breakType,
      code: response?.operatorStatus?.breakCode,
      start: response?.operatorStatus?.startedAt,
      logId: response?.operatorStatus?.operatorBreakLogId,
      breakViolationDuration,
      timeDiff,
      helpPartnerDuration,
      helpRequest,
    },
  };
};

export default getMonitoringStatusResponse;
